import { motion, useReducedMotion } from 'motion/react';

import ParentAccoladeBadge from 'images/familyHome/parent-accolade-badge.svg';

const PARENT_VARIANT = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const createSlideInVariants = prefersReducedMotion => ({
  hidden: { opacity: 0, y: prefersReducedMotion ? 0 : 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      type: prefersReducedMotion ? 'tween' : 'spring',
    },
  },
});

const Accolades = ({ data, featuredInAnimationComplete }) => {
  const { heading, body, badgeAlt } = data;
  const prefersReducedMotion = useReducedMotion();
  const slideInVariants = createSlideInVariants(prefersReducedMotion);

  return (
    <section className="flex justify-center bg-family-beige-100 px-4 pb-14 pt-8 bp2:py-20">
      <motion.div
        variants={PARENT_VARIANT}
        initial="hidden"
        whileInView={featuredInAnimationComplete ? 'visible' : 'hidden'}
        viewport={{ once: true, amount: 0.5 }}
        className="flex max-w-5xl flex-col items-center gap-8 bp2:flex-row bp3:gap-40"
      >
        <motion.img
          src={ParentAccoladeBadge}
          alt={badgeAlt}
          className="max-w-64 bp2:max-w-sm bp3:max-w-md"
          variants={slideInVariants}
        />
        <motion.div
          className="flex max-w-sm flex-col items-center bp1:max-w-md bp2:-order-1"
          variants={slideInVariants}
        >
          <h2 className="h1 pb-6 text-center text-green-140 bp2:pb-8">{heading}</h2>
          <p className="textMd bp2:h5 text-center text-green-140">{body}</p>
        </motion.div>
      </motion.div>
    </section>
  );
};

Accolades.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    badgeAlt: PropTypes.string.isRequired,
  }).isRequired,
  featuredInAnimationComplete: PropTypes.bool.isRequired,
};

export default Accolades;
